import API from '../apis';
const authData = {
    authenticated: localStorage.getItem('authenticated') ? true : false,
    userBase: localStorage.getItem('userBase') ? JSON.parse(localStorage.getItem('userBase')) : {},
    userInfo: {},
    isLoginDisabled:false
}

const state = () => ({
    user: Object.assign({}, authData)
})
const getters = {
    isLogin: state => state.user.authenticated,
    userBase: state => state.user.userBase,
    isLoginDisabled:state => state.user.isLoginDisabled,
}
const mutations = {
    ['update_isLoginDisabled'](state,data){
        state.user.isLoginDisabled = data
    },
    ['login-success'](state, data) {
        state.user.authenticated = true
        localStorage.setItem('authenticated', 1)
        state.user.userBase = data
        localStorage.setItem('userBase', JSON.stringify(data))
    },
    ['logout'](state) {
        localStorage.removeItem('authenticated')
        localStorage.removeItem('userBase')
        sessionStorage.removeItem('user-key')
        state.user.authenticated = false;
        state.user.userBase = {};
    },
}
const actions = {
    async ['get-captcha-data']({ dispatch }) {
        return new Promise((resolve, reject) => {
            API.getCaptcha().then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    async ['api-login']({ dispatch, commit }, payload) {
        let post_data = payload.login_data.value
        post_data.hashkey = payload.captcha_data.value.hashkey
        // if (!post_data.hashkey) {
        //     let res = { status: 400, data: { error_type: 'captcha', message: '未正确获取到验证码图片。' } }
        //     dispatch('response/set-response', res, { root: true })
        //     return
        // }
        if (!post_data.username) {
            let res = { status: 400, data: { error_type: 'username', message: '请填写登录名。' } }
            dispatch('response/set-response', res, { root: true })
            return
        }
        if (!post_data.password) {
            let res = { status: 400, data: { error_type: 'password', message: '请填写登录密码。' } }
            dispatch('response/set-response', res, { root: true })
            return
        }
        if (!post_data.captcha) {
            let res = { status: 400, data: { error_type: 'captcha', message: '请填写图片验证码。' } }
            dispatch('response/set-response', res, { root: true })
            return
        }
        await API.login(post_data).then(res => {
            commit('login-success', res.data.data);
            payload.gotoHome();
        })
    },
    //收到登陆失效的消息，走退出登录流程
    async ['received_login_disable']({ state, commit, dispatch }) {
        if (process.env.NODE_ENV === "development" && localStorage.getItem('more-device-online') === 'open') {
            return
        }
        commit('update_isLoginDisabled', true)
        dispatch('channel/socket_close', null, { root: true })
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
